// ================ Action types ================ //

import { LANGUAGE_COOKIE_KEY, getLangFromUrl } from '../util/locale';
import Cookies from 'js-cookie';

export const DISABLE_SCROLLING = 'app/ui/DISABLE_SCROLLING';
export const CHANGE_LANGUAGE = 'app/ui/CHANGE_LANGUAGE';

// ================ Reducer ================ //

const initialState = {
  disableScrollRequests: [],
  interfaceLang: Cookies.get(LANGUAGE_COOKIE_KEY) || getLangFromUrl(),
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case DISABLE_SCROLLING: {
      const { componentId, disableScrolling } = payload;
      const disableScrollRequests = state.disableScrollRequests;
      const componentIdExists = disableScrollRequests.find(c => c.componentId === componentId);

      if (componentIdExists) {
        const disableScrollRequestArray = disableScrollRequests.map(c => {
          return c.componentId === componentId ? { ...c, disableScrolling } : c;
        });
        return { ...state, disableScrollRequests: [...disableScrollRequestArray] };
      }

      const disableScrollRequestArray = [
        ...disableScrollRequests,
        { componentId, disableScrolling },
      ];
      return {
        ...state,
        disableScrollRequests: disableScrollRequestArray,
      };
    }

    case CHANGE_LANGUAGE:
      Cookies.set(LANGUAGE_COOKIE_KEY, payload);

      return { ...state, interfaceLang: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const manageDisableScrolling = (componentId, disableScrolling) => ({
  type: DISABLE_SCROLLING,
  payload: { componentId, disableScrolling },
});

export const changeLang = interfaceLang => ({
  type: CHANGE_LANGUAGE,
  payload: interfaceLang,
});

// ================ Selectors ================ //

export const isScrollingDisabled = state => {
  const { disableScrollRequests } = state.ui;
  return disableScrollRequests.some(r => r.disableScrolling);
};

export const changeInterfaceLang = lang => (dispatch, getState, sdk) => {
  dispatch(changeLang(lang));

  const { currentUser } = getState().user;

  if (!currentUser) return Promise.resolve(true);

  return sdk.currentUser
    .updateProfile({ publicData: { language: lang } })
    .then(() => {})
    .catch(() => {});
};
